import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import PlaceholderImage from "images/png/discography-image-placeholder.png";
import { Colors } from "utils/colors";

const ReleaseItemWeb = () => {
  return (
    <Container>
      <Header>
        <div></div>
        <Typography color={Colors.grey500} size="xs">
          Total Streams
        </Typography>
        <Typography color={Colors.grey500} size="xs">
          Spotify
        </Typography>
        <Typography color={Colors.grey500} size="xs">
          Apple
        </Typography>
        <Typography color={Colors.grey500} size="xs">
          Deezer
        </Typography>
        <Typography color={Colors.grey500} size="xs">
          Amazon
        </Typography>
        <Typography color={Colors.grey500} size="xs">
          Youtube
        </Typography>
      </Header>
      <Body>
        <FirstRow>
          <TrackImage src={PlaceholderImage} alt="cover-image" />
          <div>
            <Typography
              size="xl"
              weight="medium"
              mb="0.4"
              color={Colors.white300}
            >
              The Vibe
            </Typography>
            <Typography size="s" color={Colors.grey400}>
              Vectra, Sammy T Beatz
            </Typography>
          </div>
        </FirstRow>
        <Typography weight="medium">
          {Number("12675").toLocaleString()}
        </Typography>
        <Typography weight="medium">
          {Number("3001").toLocaleString()}
        </Typography>
        <Typography weight="medium">
          {Number("4017").toLocaleString()}
        </Typography>
        <Typography weight="medium">
          {Number("2600").toLocaleString()}
        </Typography>
        <Typography weight="medium">
          {Number("1554").toLocaleString()}
        </Typography>
        <Typography weight="medium">
          {Number("1500").toLocaleString()}
        </Typography>
      </Body>
    </Container>
  );
};

export default ReleaseItemWeb;

const Container = styled.div`
  display: block;

  @media only screen and (max-width: 769px) {
    display: none;
  }
`;

const Header = styled.div`
  align-items: center;
  justify-content: space-between;
  display: grid;
  grid-template-columns: 22% 12% 12% 12% 12% 12% 12%;
  margin-bottom: 1.1rem;
  padding: 0 3.2rem;
`;
const Body = styled.div`
  width: 100%;
  border-radius: 4px;
  background: ${Colors.grey700};
  padding: 1.2rem 3.2rem;
  align-items: center;
  justify-content: space-between;
  display: grid;
  grid-template-columns: 22% 12% 12% 12% 12% 12% 12%;
`;

const TrackImage = styled.img`
  width: 6.4rem;
  height: 6.4rem;
  object-fit: cover;
`;

const FirstRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
`;
